import { IGetShiftsResponse, IShift, IShiftDetail, ShiftStatusesEnum } from "./types";
import axios from "axios";

export const getShiftDetail = (shiftId: number) => {
  const url = `/shift/${shiftId}/`;
  return axios.get<IShiftDetail>(url);
}